export default "__VITE_ASSET__D5j5RTtn__"